import React from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

const FeatureCard = ({ feature }) => {
  const { ss, feature: featureTxt } = feature;
  return (
    <div className="flex gap-12 mb-16 items-center justify-center lg:flex-row md:flex-row sm:flex-col flex-col">
      <div>
        <h2 className="hover:scale-105 transition-all ease-in-out delay-75 duration-500 rounded-2xl hover:text-green-500 lg:text-start md:text-start sm:text-center text-center lg:mx-0 md:mx-0 sm:mx-auto mx-auto">
          {featureTxt}
        </h2>
      </div>
      <div>
        <PhotoProvider>
          <PhotoView src={ss}>
            <img
              src={ss}
              className="hover:scale-105 transition-all ease-in-out delay-75 duration-500 rounded-2xl hover:bottom-0 lg:w-full md:w-full sm:w-10/12 w-11/12 lg:mx-0 md:mx-0 sm:mx-auto mx-auto"
              alt=""
            />
          </PhotoView>
        </PhotoProvider>
      </div>
    </div>
  );
};

export default FeatureCard;
